import classNames from "classnames";
import { observer } from "mobx-react-lite";
import React, { useContext } from "react";
import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";
import { translationHookOptions } from "../../app/localization/localization";
import { ITenant } from "../../app/models/tenant";
import { RootStoreContext } from "../../app/stores/rootStore";
import SidebarGenericButton from "./SidebarGenericButton";

interface IParams {
  tenant: ITenant;
  currentUrl?: string;
}

const SidebarOdgButton: React.FC<IParams> = ({ tenant, currentUrl }) => {
  const rootStore = useContext(RootStoreContext);
  const { currentTenant , canViewODG} = rootStore.tenantStore;
  const { enabledRepository } = rootStore.playerStore;
  const { sourceId } = rootStore.meetingStore;
  const { isMobileMediaQuery, setIsSidebarModalOpen } = rootStore.responsiveStore;
  const [t] = useTranslation(["translation"], translationHookOptions);

  return (
    <>
    {canViewODG && (<>
      {sourceId ? (
        <div
          className={classNames(
            isMobileMediaQuery ? "col-6 mobileSidebarButtonContainer" : "",
            "pt-0 pb-0"
          )}
        >
          <Link
            to={`${currentTenant!.path}/meeting/${sourceId}`}
            className=" pb-0"
            onClick={()=> isMobileMediaQuery && setIsSidebarModalOpen(false)}
          >
            <SidebarGenericButton
              icon={"fas fa-list"}
              label={t("sidebar_btn_odg")}
              isActive={currentUrl === `${tenant.path}/meeting/${sourceId}`}
            />
          </Link>
        </div>
      ) : ( !isMobileMediaQuery ?
        <div
          className={classNames(
            isMobileMediaQuery ? "col-6 mobileSidebarButtonContainer" : "",
            "pt-0 pb-0"
          )}
        >
          <a href="/#" className="pb-0" onClick={(e) => e.preventDefault()}>
            <div
              className={classNames(
                isMobileMediaQuery
                  ? `sidebarMobileButton sidebarButton btn`
                  : "sidebarButton"
              )}
            ></div>
          </a>
        </div> 
        :null
      )}

    </>)}
    
    </>
  );
};

export default observer(SidebarOdgButton);
